import type { Apis } from '@efdigital/ll-addon-auth/types/apis';
import config from '@efdigital/ll-xceed-v2/config/environment';
import type { ConstrainedRequestOptions } from '@warp-drive/core/types/request';

const apis: Apis = config['ll-addon-auth-apis'];

export const jsonApiOptions: ConstrainedRequestOptions = {
  ...apis.jsonApi,
  urlParamsSettings: {
    arrayFormat: 'repeat',
  },
};

export function filterRegex(
  prefix: string,
  value: string,
  caseSensitive: boolean = false
): Record<string, string> {
  if (typeof value !== 'string' || !value.length) {
    return {};
  }

  return {
    [`${prefix}[$regex]`]: value.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&'),
    [`${prefix}[$options]`]: caseSensitive ? '' : 'i',
  };
}

export function filterText(text: string): Record<string, string> {
  if (typeof text !== 'string' || !text.length) {
    return {};
  }

  return {
    [`filter[$text][$search]`]: text,
  };
}

export function filterOr(
  prefix: string,
  key: string,
  values: string[]
): Record<string, string> {
  return Array.from(new Set(values)).reduce(
    (filters, userId, index) => {
      filters[`${prefix}[$or][${index}]${key}`] = userId;
      return filters;
    },
    {} as Record<string, string>
  );
}

export type PageOptions = {
  offset: number;
  limit: number;
};

export function page({ offset, limit }: PageOptions) {
  return {
    'page[offset]': offset,
    'page[limit]': limit,
  };
}

export function include(includes: string[]) {
  return {
    'include[]': includes,
  };
}

export function sort(field: string) {
  return {
    'sort[]': field,
  };
}
